(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxConditionEnumReference', {
		bindings: { condition: '=' },
		controller: MxConditionEnumReferenceCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-condition-builder/by-type/mx-condition-enum-reference.html',
	});

	MxConditionEnumReferenceCtrl.$inject = [];

	function MxConditionEnumReferenceCtrl() {
		var vm = this;

		vm.$onInit = function () {};
		return vm;
	}
})();
